import { Button, DialogContent } from '@mui/material';
import { DialogActions, RoutedDialog } from '@tsp-ui/core/components';
import { useState } from 'react';

import LockAvailabilityHolidayForm from './LockAvailabilityHolidayForm';


export function LockAvailabilityHolidayDialog() {
    const [ loading, setLoading ] = useState(false);

    return (
        <RoutedDialog
            title="Holiday lock availability"
            maxWidth={false}
            closeTo=".."
            loading={loading}
        >
            <DialogContent>
                <LockAvailabilityHolidayForm setLoading={setLoading} />
            </DialogContent>

            <DialogActions loading={loading}>
                <Button
                    type="submit"
                    form={LockAvailabilityHolidayForm.formID}
                    variant="contained"
                >
                    Save
                </Button>
            </DialogActions>
        </RoutedDialog>
    );
}
